import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoImg from "../../assets/svg/LogoFooter";
import EmailIcon from "../../assets/img/email.png";
import WhatsAppIcon from "../../assets/img/whatsapp.png";
import LinkedInIcon from "../../assets/img/linkedin.png";
import AddressIcon from "../../assets/img/address.png";
import PhoneIcon from "../../assets/img/phone.png";

export default function Footer() {
  const getCurrentYear = () => new Date().getFullYear();

  return (
    <Wrapper>
      <FooterContainer>
        {/* Logo & Brand */}
        <LogoSection>
          <Link to="home" smooth={true} offset={-80} className="flexCenter">
            <LogoImg />
            <BrandText>
              <h1>nFinity Solutions</h1>
              <Tagline>Automation, and Next-Gen Software Solutions</Tagline>
            </BrandText>
          </Link>
          <p>© {getCurrentYear()} nFinity Solutions. All Rights Reserved.</p>
        </LogoSection>

        {/* Pakistan Office */}
        <OfficeSection>
          <h4>Pakistan Office</h4>
          <ContactItem>
            <img src={AddressIcon} alt="Address" /> Tajpura LDA Scheme, Lahore, Pakistan
          </ContactItem>
          <ContactItem>
            <img src={PhoneIcon} alt="Phone" /> +92 304 4488506
          </ContactItem>
          <ContactItem>
            <img src={EmailIcon} alt="Email" /> <a href="mailto:info@nfinitysolution.com">info@nfinitysolution.com</a>
          </ContactItem>
        </OfficeSection>

        {/* UK Office */}
        <OfficeSection>
          <h4>UK Office</h4>
          <ContactItem>
            <img src={AddressIcon} alt="Address" /> 10 Downing Street, London, UK
          </ContactItem>
          <ContactItem>
            <img src={PhoneIcon} alt="Phone" /> +44 79 0744 3430
          </ContactItem>
          <ContactItem>
            <img src={EmailIcon} alt="Email" /> <a href="mailto:info-uk@nfinitysolution.com">info-uk@nfinitysolution.com</a>
          </ContactItem>
        </OfficeSection>

        {/* Social Links */}
        <SocialSection>
          <h4>Connect With Us</h4>
          <SocialLinks>
            <a href="https://www.linkedin.com/company/nfinitysolutions/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
              <img src={LinkedInIcon} alt="LinkedIn" />
            </a>
            <a href="https://wa.me/923044488506" target="_blank" rel="noopener noreferrer">
              <img src={WhatsAppIcon} alt="WhatsApp" />
            </a>
          </SocialLinks>
        </SocialSection>

        {/* Back to Top */}
        <BackToTop>
          <Link to="home" smooth={true} offset={-80}>↑ Back to Top</Link>
        </BackToTop>
      </FooterContainer>
    </Wrapper>
  );
}

// Styled Components
const Wrapper = styled.footer`
  width: 100%;
  background-color: #090f52;
  color: #fff;
  padding: 60px 0 30px;
`;

const FooterContainer = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  h1 {
    font-size: 22px;
    color: #fff;
  }

  p {
    font-size: 14px;
    color: #aaa;
  }

  a.flexCenter {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    color: #fff;
    transition: all 0.3s ease;
    &:hover { color: #580cd2; }
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 6px;
    }
  }

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const BrandText = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`;

const Tagline = styled.div`
  font-size: 13px;
  color: #ccc;
`;

const OfficeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  a {
    color: #fff;
    text-decoration: none;
    transition: color 0.3s ease;
    &:hover { color: #580cd2; }
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;

  img {
    width: 20px;
    height: 20px;
  }
`;

const SocialSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;

  a img {
    width: 25px;
    height: 25px;
    transition: all 0.3s ease;
    &:hover { transform: scale(1.1); }
  }
`;

const BackToTop = styled.div`
  display: flex;
  align-items: center;

  a {
    font-size: 14px;
    color: #fff;
    text-decoration: none;
    border: 1px solid #fff;
    padding: 6px 14px;
    border-radius: 8px;
    transition: all 0.3s ease;
    &:hover {
      background-color: #580cd2;
      border-color: #580cd2;
      color: #fff;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;
